import React, { useContext, useEffect } from 'react';
import img1 from '../images/bg-desktop-light.jpg';
import img2 from '../images/bg-desktop-dark.jpg'
import { Theme_context } from '../context/theme-context';
export default function Background() {
    let theme_value = useContext(Theme_context);
    return (
    <div style={{
        backgroundImage : `url(${theme_value.theme === 'light' ? img1 : img2})`
    }} className='background-img'></div>
  )
}
